import { render } from "./AccompanistProfile.vue?vue&type=template&id=0df4bb4a&scoped=true"
import script from "./AccompanistProfile.vue?vue&type=script&lang=js"
export * from "./AccompanistProfile.vue?vue&type=script&lang=js"

import "./AccompanistProfile.vue?vue&type=style&index=0&id=0df4bb4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df4bb4a"]])

export default __exports__